import React from "react";
import ShowTemas from './ShowTemas'


const JurisprudenciaCronologia = () => {
  return (
    <div id="cronologia-container"><ShowTemas/></div>
    
  )
};
export default JurisprudenciaCronologia;
